import { noSpecialCharacters } from '@/composables/regex'

type CampaignType = string | string[] | null | undefined

interface CanProceedToValidationStepOptions {
  campaignType: CampaignType
  campaignName: string
  hasMessageContentError: boolean
  messageContent: string
  messageLength: number
  messageMaxLength: number
  optinTargets: number
}

export const hasInvalidCampaignMessageCharacters = (campaignType: CampaignType, messageContent: string) => {
  return campaignType === 'sms' && noSpecialCharacters(messageContent)
}

export const canProceedToValidationStep = ({
  campaignType,
  campaignName,
  hasMessageContentError,
  messageContent,
  messageLength,
  messageMaxLength,
  optinTargets
}: CanProceedToValidationStepOptions) => {
  return Boolean(
    messageContent &&
      messageLength > 0 &&
      messageLength <= messageMaxLength &&
      optinTargets > 0 &&
      campaignName.length > 0 &&
      !hasMessageContentError &&
      !hasInvalidCampaignMessageCharacters(campaignType, messageContent)
  )
}
